export default __webpack_public_path__ + "static/media/allen-key.bf3b5ab0.svg";